module.exports = __webpack_public_path__ + "img/ModularWallV4.fe4640d1.jpg";